"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castelraimondo": {
    "2b382346": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "lanciano": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1cc2c62": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "marzolari": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e1537755": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "masconi": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c1065beb": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "nani": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5aa25fca": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "roccafranca": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd625594": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "seano": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f102f06a": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "stroppigliosi": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e77b8288": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "torre-del-parco": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88d00b0a": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "torricella": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e9cfc998": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "vagliole": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "876f66d7": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "skipSearch": false
    }],
    "valeano": [{
      "hkey": "b9e54e5a",
      "slug": "castelraimondo",
      "name": "Castelraimondo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;